import { render } from "./Publication.vue?vue&type=template&id=7c0fbfce&scoped=true"
import script from "./Publication.vue?vue&type=script&lang=js"
export * from "./Publication.vue?vue&type=script&lang=js"

import "./Publication.vue?vue&type=style&index=0&id=7c0fbfce&lang=scss&scoped=true"

import exportComponent from "/opt/cah/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7c0fbfce"]])

export default __exports__